import { useEffect, useState, memo, useRef } from 'react';
import { Modal } from 'antd';
import RechargeRecordRender, { IRechargeRecordRenderContext } from '../recharge-record-render';
import { eventBusExample, queryDomExample } from '@/sub-luca-plugin/utils/class-example';
import classNames from 'classnames';
import './index.scss';

const RechargeRecordModal = () => {
    const rechargeRecordRenderContext = useRef<IRechargeRecordRenderContext>();
    const [projectId, setProjectId] = useState<number>();
    const [refreshLoading, setRefreshLoading] = useState(false);

    const handleRefresh = async () => {
        setRefreshLoading(true);
        await rechargeRecordRenderContext.current?.refresh();
        setTimeout(() => setRefreshLoading(false), 1000);
    };

    const handleClose = () => setProjectId(undefined);

    useEffect(() => {
        eventBusExample.subscribe('RechargRecordModal', ({ type, params }) => {
            switch (type) {
                case 'open':
                    setProjectId(params?.projectId);
                    break;
                default:
                    handleClose();
                    break;
            }
        });
    }, []);

    return (
        <Modal
            centered
            width={860}
            className="recharge-record-modal"
            open={!!projectId}
            title=""
            closable={false}
            footer={null}
            getContainer={queryDomExample.queryLucaQaRoot}
            zIndex={1900}
            destroyOnHidden
        >
            <div className="recharge-record-modal__header">
                <div className="recharge-record-modal__header-left">
                    <span className="recharge-record-modal__title">购买记录</span>
                    <div
                        className={classNames('recharge-record-modal__refresh', refreshLoading && 'recharge-record-modal__refreshing')}
                        onClick={handleRefresh}
                    />
                </div>
                <div className="recharge-record-modal__close" onClick={handleClose} />
            </div>
            <div className="recharge-record-modal__scroll-container">
                <RechargeRecordRender projectId={projectId} ref={rechargeRecordRenderContext} />
            </div>
        </Modal>
    );
};

export default memo(RechargeRecordModal);
